// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"bba3bf0d","260":"904139d8","453":"1cc80243"}[chunkId] + ".chunk.js";
};